import styled from '~/ui/styled'

const FeildFloatLabel = styled.Text`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.fontSizes.md};
  padding: ${({ theme }) => theme.space.sm} 0;
`

export default FeildFloatLabel
